/**
 * author: Soumya Shreyas
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useHasPermission from "../../core/hooks/useHasPermission";

function FormBuilderCallback() {
  const navigate = useNavigate();
  const { hasDataCollectionViewPermission } = useHasPermission();
  useEffect(() => {
  var data = JSON.parse(localStorage.getItem("authority"));

  if (data.roles.includes("SUPER_ADMIN")) {
    navigate({
      pathname: "/admin/assessments",
    });
  } else{
    navigate({
          pathname: "/company_admin/assessments",
    })
  }

  //end

  /********************these are the old permissions before keyclock chnages***************************** */
  
  // if (data.roles.includes("SUPPLIER_ADMIN")) {
  //   navigate({
  //     pathname: "/company_admin/assessments",
  //   });
  // }
}, []);
}

export default FormBuilderCallback;
